const useSessionStorage = process.env.USE_SESSION_STORAGE === 'true'
let storage: Storage | null = null
if (typeof window !== 'undefined') {
  storage = useSessionStorage ? window.sessionStorage : window.localStorage
}
export const loadState = () => {
  try {
    const localState = localStorage.getItem('state')
    const sessionState = sessionStorage.getItem('state')
    if (useSessionStorage && localState && !sessionState) {
      // Migrate local storage state to session storage
      sessionStorage.setItem('state', localState)
      localStorage.removeItem('state')
    } else if (!useSessionStorage && sessionState && !localState) {
      // Migrate session storage state to local storage
      localStorage.setItem('state', sessionState)
      sessionStorage.removeItem('state')
    }
    const serializedState = storage?.getItem('state')
    if (!serializedState) {
      return undefined
    }
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}
export const clearState = () => storage?.removeItem('state')
export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify({ state })
    storage?.setItem('state', serializedState)
  } catch (err) {
    // Ignore write errors.
  }
}
